import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from '../components/member/pages/HomePage';
import SupportPage from '../components/member/pages/SupportPage';
import SettingsPage from '../components/member/pages/SettingsPage';
import TripsPage from '../components/member/pages/TripsPage';
import TripDetailsPage from '../components/member/pages/TripDetailsPage';
import * as userSlice from '../data/user.slice';
import { useAppSelector } from '../hooks/useAppSelector';
import { useIsPassengerPortalUser } from '../hooks/useIsPassengerPortalUser';
import { useIsClientPortalUser } from '../hooks/useIsClientPortalUser';
import { useIsClientPortalAdminUser } from '../hooks/useIsClientPortalAdminUser';
import Passengers from '../components/home/passengers/Passengers';
import { ClientUsers } from '../components/home/admin/ClientUsers';
import Passenger from '../components/home/passengers/Passenger';
import ReservationDetailsPage from '../components/home/reservations/ReservationDetailsPage';
import Settings from '../components/home/admin/Settings';
import { CreateReservationPage } from '@/components/reservations/CreateReservationPage';

const MemberHomeRouting = () => {
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);
  const isPassengerPortalUser = useIsPassengerPortalUser();
  const isClientPortalUser = useIsClientPortalUser();
  const isClientPortalAdminUser = useIsClientPortalAdminUser();

  // TODO: Uncomment this when user info loads properly
  // if (!userInfo) {
  //   return null;
  // }

  const passengerPortalRoutes = [
    <Route
      key="home-redirect"
      path="/"
      element={<Navigate to="/home" replace />}
    />,
    <Route key="home" path="home" element={<HomePage />} />,
    <Route key="trips" path="trips" element={<TripsPage />} />,
    <Route
      key="trip-details"
      path="trip-details/:reservationReferenceId/:tripLegReferenceId"
      element={<TripDetailsPage />}
    />,
    <Route key="support" path="support" element={<SupportPage />} />,
    <Route key="settings" path="settings" element={<SettingsPage />} />,
    <Route key="index" index element={<Navigate to="/home" replace />} />,
  ];

  const clientPortalRoutes = [
    <Route
      key="client-redirect"
      path="/"
      element={<Navigate to="/passengers" replace />}
    />,
    <Route key="passengers" path="passengers" element={<Passengers />} />,
    <Route
      key="passenger-details"
      path={'/passengers/:id'}
      element={<Passenger />}
    />,
    <Route
      key="create-reservation"
      path={'/passengers/:id/create-reservation'}
      element={<CreateReservationPage />}
    />,
    <Route
      key="reservation-details"
      path={'/passengers/:passengerId/reservations/:referenceId'}
      element={<ReservationDetailsPage />}
    />,
    <Route
      key="client-settings"
      path="settings"
      element={isClientPortalAdminUser ? <Settings /> : <SettingsPage />}
    />,
    <Route
      key="client-index"
      index
      element={<Navigate to="/passengers" replace />}
    />,
  ];

  const clientAdminPortalRoutes = [
    <Route key="users" path="users" element={<ClientUsers />} />,
  ];

  return (
    <Routes>
      {(() => {
        if (isClientPortalUser || isClientPortalAdminUser) {
          let routes = clientPortalRoutes;
          if (isClientPortalAdminUser) {
            routes = routes.concat(clientAdminPortalRoutes);
          }
          return <>{routes}</>;
        } else if (isPassengerPortalUser) {
          return <>{passengerPortalRoutes}</>;
        }
        return <></>;
      })()}
      <Route path="*" element={<Navigate to={'/'} replace />} />
    </Routes>
  );
};

export default MemberHomeRouting;
